import { render, staticRenderFns } from "./setupStatistics.vue?vue&type=template&id=91a8620a&scoped=true"
import script from "./setupStatistics.vue?vue&type=script&lang=js"
export * from "./setupStatistics.vue?vue&type=script&lang=js"
import style0 from "./setupStatistics.vue?vue&type=style&index=0&id=91a8620a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a8620a",
  null
  
)

export default component.exports